import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import loading from './loading';
import reserve from './reserve';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        loading,
        reserve
    }
});
